import { render, staticRenderFns } from "./AthleteVideoStudio.vue?vue&type=template&id=3eb1b44e&scoped=true&"
import script from "./AthleteVideoStudio.vue?vue&type=script&lang=ts&"
export * from "./AthleteVideoStudio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb1b44e",
  null
  
)

export default component.exports